// @flow

import React from "react";

import * as colors from "src/styles/constants/colors";

type Props = {
  size?: number,
  isDisabled?: boolean
};

const DefaultPicklistCheckbox = ({ size = 24, isDisabled = false }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}px`}
    viewBox="0 0 24 24"
    width={`${size}px`}
    fill={isDisabled ? colors.grey35 : "transparent"}
  >
    <rect x="0" y="0" width="24" height="24" rx="3" />
    <rect
      x="1"
      y="1"
      width="22"
      height="22"
      rx="3"
      fill="none"
      stroke="#e8eaed"
      strokeWidth="2"
    />
  </svg>
);

export default DefaultPicklistCheckbox;
